/**
 * Copyright ©2023 Drivepoint
 */

import FeatureFlagsService from "./FeatureFlagService";

export type TemplateRunOptions = {
  additionalLibraries?: any[];
  globals?: any;
};

export default class Template {

  static AsyncFunction = async function(): Promise<void> {}.constructor;

  static parse(template: string, data?: any, options: TemplateRunOptions = {}): any {
    if (data != null && typeof data === "string") { throw new Error("data must be object"); }
    const {declarations, parameters} = Template._getJavascriptConfiguration(data, options);
    const body: string[] = [
      ...declarations,
      "return `" + template + "`;"
    ];
    try {
      return Function(body.join("\n"))(...parameters);
    } catch (error: any) {
      return template;
    }
  }

  private static _getJavascriptConfiguration(data: any, options: TemplateRunOptions): {declarations: string[], parameters: any[]} {
    const globals: any = {
      window: {},
      document: {},
      globalThis: {},
      $: options.globals ?? {},
      $FEATURES: FeatureFlagsService.featureFlags,
      ...data
    };
    const libraries: any[] = [...(options.additionalLibraries ?? [])];
    const functions: any[] = [];
    functions.push(...libraries.map(library => library.functions(globals))?.flat() ?? []);
    globals.$LIB = functions.reduce((functions: any, functionEntry: any) => {
      if (functionEntry.namespace) {
        if (!functions[functionEntry.namespace]) { functions[functionEntry.namespace] = {}; }
        functions[functionEntry.namespace][functionEntry.name] = functionEntry.fn;
      } else {
        functions[functionEntry.name] = functionEntry.fn;
      }
      return functions;
    }, {});
    const declarations: string[] = Object.keys(globals).map((key, index) => `let ${key}=arguments[${index}];`);
    const parameters: any[] = Object.values(globals);
    return {declarations, parameters};
  }

}
